import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

export const PageIntro = ({ label, title, desc, children }) => (
  <section className="relative z-10 mx-auto max-w-4xl px-4 pt-36 sm:px-6 md:pt-44">
    <motion.div variants={fadeUp} initial="hidden" animate="show">
      {label && (
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-teal-400">
          {label}
        </span>
      )}
      <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tighter text-white sm:text-5xl md:text-6xl">
        {title}
      </h1>
      {desc && (
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/60 md:text-lg">
          {desc}
        </p>
      )}
      {children}
    </motion.div>
  </section>
);
